import React from "react";
import { useState, useEffect } from "react";
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  Grid,
  Radio,
  Row,
} from "react-bootstrap";
import icon from "../../img/app_control.png";
import { Group, AutomaticalSyncSetting } from "../../utils/types";
import { APP_ENDPOINT } from "../../utils/constants";
import { GROUP_DEFAULT_VALUE } from "../../Schedule";

type ScheduleFormProps = {
  defaultValue?: AutomaticalSyncSetting;
  groups: Group[];
  saveButtonDisable?: boolean;
  onSubmit: (params: AutomaticalSyncSetting) => void;
};

function ScheduleForm({
  defaultValue,
  groups,
  saveButtonDisable,
  onSubmit,
}: ScheduleFormProps) {
  const [scheduleEnabled, setScheduleEnabled] = useState(
    defaultValue ? defaultValue.scheduleEnabled : false,
  );
  const [group, setGroup] = useState(
    defaultValue ? defaultValue.group : GROUP_DEFAULT_VALUE,
  );
  const [query, setQuery] = useState(defaultValue ? defaultValue.query : "");
  const [enableDelete, setEnableDelete] = useState<"true" | "false">(
    defaultValue ? defaultValue.enableDelete : "false",
  );

  useEffect(() => {
    if (group !== "All" || query !== "") {
      setEnableDelete("false");
    }
  }, [group, query]);

  return (
    <Grid>
      <Col
        sm={4}
        style={{
          marginTop: "10px",
        }}
      >
        <a href={APP_ENDPOINT + "/sync"} id="linkSync">
          Back to Synchronization
        </a>
      </Col>
      <Col
        sm={8}
        className="button-group"
        style={{
          marginTop: "10px",
          justifyContent: "flex-end",
        }}
      >
        <button
          className="rsi-button is-primary"
          type="button"
          id="saveButton"
          disabled={saveButtonDisable}
          onClick={() =>
            onSubmit({
              scheduleEnabled: scheduleEnabled,
              group,
              query,
              enableDelete: enableDelete,
            })
          }
        >
          Save
        </button>
      </Col>
      <Col
        sm={12}
        style={{
          background: "#FFFFFF",
          marginTop: "10px",
          paddingBottom: "10px",
        }}
      >
        <Col sm={12} className="App">
          <h2>
            <img src={icon} className="top-menu-icon" />
            Google Workspace Directory Automatic Synchronization Setting
          </h2>
          <div className="rsi-title">Scheduled Execution</div>
          <Form horizontal>
            <Row style={{ alignItems: "center", display: "flex" }}>
              <Col componentClass={ControlLabel} sm={4}>
                <label>Synchronize users every day</label>
              </Col>
              <Col sm={8} className="button-group">
                <Radio
                  data-testid="shedule-disabled"
                  name="execution"
                  checked={scheduleEnabled === false}
                  onChange={() => setScheduleEnabled(false)}
                >
                  Disabled
                </Radio>
                <Radio
                  data-testid="shedule-enable"
                  name="execution"
                  checked={scheduleEnabled === true}
                  onChange={() => setScheduleEnabled(true)}
                >
                  Enabled
                </Radio>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col sm={12} className="App">
          <div className="rsi-title">Get user list settings</div>
          <Form horizontal>
            <Row>
              <Col componentClass={ControlLabel} sm={2}>
                <label>group</label>
              </Col>
              <Col sm={10}>
                <FormControl
                  data-testid="groupSelect" //TODO: testIdに頼らないようにMTを修正する
                  id="groupSelect"
                  componentClass="select"
                  value={group}
                  disabled={!scheduleEnabled}
                  onChange={(event: any) => {
                    setGroup(event.target.value);
                  }}
                >
                  {[
                    <option key="domain" value={GROUP_DEFAULT_VALUE}>
                      All
                    </option>,
                    ...groups.map(group => {
                      return (
                        <option key={group.id} value={group.email}>
                          {group.name} : {group.email}
                        </option>
                      );
                    }),
                  ]}
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col componentClass={ControlLabel} sm={2}>
                <label>query</label>
              </Col>
              <Col sm={10}>
                <FormControl
                  data-testid="queryInput" //TODO: testIdに頼らないようにMTを修正する
                  id="queryInput"
                  type="text"
                  value={query}
                  disabled={!scheduleEnabled}
                  onChange={(event: any) => {
                    setQuery(event.target.value);
                  }}
                  placeholder="directManager='bobjones@example.com'"
                />
              </Col>
            </Row>
          </Form>
        </Col>
        <Col sm={12} className="App">
          <div className="rsi-title">Settings for Synchronization</div>
          <Form horizontal>
            <Row style={{ alignItems: "center", display: "flex" }}>
              <Col componentClass={ControlLabel} sm={4}>
                <label>Delete users when run synchronization</label>
              </Col>
              <Col sm={8} className="button-group">
                <Radio
                  data-testid="sync-disabled"
                  name="synchronization"
                  disabled={!scheduleEnabled || group !== "All" || query !== ""}
                  checked={enableDelete === "false"}
                  onChange={() => setEnableDelete("false")}
                >
                  Disabled
                </Radio>
                <Radio
                  data-testid="sync-enable"
                  name="synchronization"
                  disabled={!scheduleEnabled || group !== "All" || query !== ""}
                  checked={enableDelete === "true"}
                  onChange={() => setEnableDelete("true")}
                >
                  Enable
                </Radio>
              </Col>
            </Row>
          </Form>
        </Col>
      </Col>
    </Grid>
  );
}

export default ScheduleForm;
